import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Plus } from "lucide-react";
 * // Use <Plus /> instead
 */
export const PlusIcon = createSVGWrapper(
  <path
    fill="currentColor"
    d="M20 12a1 1 0 0 0-1-1h-6V5a1 1 0 1 0-2 0v6H5a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 0 0 1-1Z"
  />
);
